import { render, staticRenderFns } from "./anchor-container.vue?vue&type=template&id=8481e708&scoped=true&"
import script from "./anchor-container.vue?vue&type=script&lang=js&"
export * from "./anchor-container.vue?vue&type=script&lang=js&"
import style0 from "./anchor-container.vue?vue&type=style&index=0&id=8481e708&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8481e708",
  null
  
)

export default component.exports